exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cb-widget .IpPinJvUWX_gHR4UzPT9b{display:flex;align-items:center;justify-content:center;height:100%;padding-right:4px;padding-left:4px;margin-left:4px;margin-right:4px;min-width:44px}.cb-widget .IpPinJvUWX_gHR4UzPT9b:active,.cb-widget .IpPinJvUWX_gHR4UzPT9b:link,.cb-widget .IpPinJvUWX_gHR4UzPT9b:visited,.cb-widget .IpPinJvUWX_gHR4UzPT9b:hover{text-decoration:none;color:#221f1f}.cb-widget .IpPinJvUWX_gHR4UzPT9b .OHYx4pfmhf0MrQbqKGyX1{margin-right:4px;font-size:14px}.cb-widget .FDSV9GC0V9ooOviZEC8KW{background-color:#fedb00}.cb-widget .FDSV9GC0V9ooOviZEC8KW::before,.cb-widget .FDSV9GC0V9ooOviZEC8KW::after{color:#000}\n", ""]);

// exports
exports.locals = {
	"root": "IpPinJvUWX_gHR4UzPT9b",
	"name": "OHYx4pfmhf0MrQbqKGyX1",
	"userIcon": "FDSV9GC0V9ooOviZEC8KW"
};